import { getCookie } from "./cookies";

function getClientIdFromCookie(): string | null {
  const match = document.cookie.match(/_ga=GA\d+\.\d+\.(\d+\.\d+)/);
  return match ? match[1] : null;
}

export const getClientId = async (): Promise<string | null> => {
  return new Promise((resolve) => {
    try {
      const gtag = (window as any).gtag;

      // Primeiro tenta via gtag
      if (typeof gtag !== "undefined") {
        gtag("get", "G-Q9PJ9VWKX4", "client_id", (clientId: string) => {
          if (clientId) {
            resolve(clientId);
          } else {
            // fallback se não houver clientId
            resolve(getClientIdFromCookie());
          }
        });
      } else {
        // se gtag não estiver disponível, tenta cookie
        resolve(getClientIdFromCookie());
      }
    } catch (e) {
      console.error("Erro ao obter client_id:", e);
      resolve(getClientIdFromCookie());
    }
  });
};

export const getGCLID = () => {
  return getCookie("_gclid");
};

export const getGBRAID = () => {
  return getCookie("_gbraid");
};

export const getWBRAID = () => {
  return getCookie("_wbraid");
};
